import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Container, InputLabel, Select, MenuItem, TextField, Stack, Autocomplete } from '@mui/material';
import { Typography, Alert } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StoreContext } from '../../components/Store';
import PropTypes from 'prop-types';
import { getStatusReference } from '../../api/util';
import { isEORIUser } from '../../utils/roles';
import { getCompanyList } from '../../api/dashboard';
const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z]+$/;

dayjs.extend(utc);

const validateDateRange = (name, event, startKey, endKey, setError, searchFilterLocal) => {
  const fromDate = name === startKey ? event : searchFilterLocal[startKey];
  const toDate = name === endKey ? event : searchFilterLocal[endKey];

  if (!fromDate || !toDate) {
    setError('Both dates are required');
    return;
  }

  if (toDate.diff(fromDate, 'month') >= 6) {
    setError(
      name.includes('departure')
        ? 'Departure Date range can not exceed 6 months'
        : 'Arrival Date range can not exceed 6 months'
    );
    return;
  }

  setError('');
};

export default function SearchContainerPanel(props) {
  const store = useContext(StoreContext);
  const [searchData, setSearchData] = useState(store?.shipmentStatusFilterData?.[0] || {});
  const [shipmentStatus, setShipmentStatus] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const { handlefilterApiCall, companySetEori } = props;
  const [value, setValue] = useState('');
  const [departureDateError, setDepartureDateError] = useState('');
  const [arrivalDateError, setArrivalDateError] = useState('');

  const resetFields = () => {
    const newSearchData = { companyId: 'null' };
    setSearchData(newSearchData);
    store.shipmentStatusFilterData[1](newSearchData);
    setValue('ALL');
    setArrivalDateError('');
    setDepartureDateError('');
    handlefilterApiCall(newSearchData);
    if (props.handleCompanyNameChange) {
      props.handleCompanyNameChange('ALL');
    }
    sessionStorage.removeItem('filterObj');
    if (props.onResetPagination) props.onResetPagination();
  };
  const filterResponse = () => {
    store.shipmentStatusFilterData[1](searchData);
    if (searchData.companyId === 'null') {
      setValue('ALL');
      if (props.handleCompanyNameChange) {
        props.handleCompanyNameChange('ALL');
      }
    } else {
      if (props.handleCompanyNameChange) {
        props.handleCompanyNameChange(value);
      }
    }
    handlefilterApiCall(searchData);
  };
  const handleOnChange = (event, name) => {
    if (event?.$isDayjsObject) {
      if (['departureStartDate', 'departureEndDate'].includes(name)) {
        validateDateRange(name, event, 'departureStartDate', 'departureEndDate', setDepartureDateError, searchData);
      } else if (['arrivalStartDate', 'arrivalEndDate'].includes(name)) {
        validateDateRange(name, event, 'arrivalStartDate', 'arrivalEndDate', setArrivalDateError, searchData);
      }

      setSearchData((prevData) => ({
        ...prevData,
        [name]: event,
      }));
    } else {
      let title = event.target.name;
      let value = event.target.value;
      setSearchData((prevData) => {
        return {
          ...prevData,
          [title]: value,
        };
      });
      if (event.target.name === 'companyId') {
        companySetEori();
      }
    }
  };
  const handleKeyDown = (event) => {
    if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
      //event.preventDefault();
    }
  };
  useEffect(() => {
    if (props.handleCompanyNameChange) {
      props.handleCompanyNameChange(value);
    }
  }, [value]);
  useEffect(() => {
    async function fetchData() {
      try {
        getStatusReference().then((data) => {
          store.shipmentStatusData[1](data);
          const orderedData = [{ statusId: 1, description: 'ALL' }, ...data];
          if (Object.keys(searchData).length === 0 && searchData.constructor === Object) {
            setSearchData((prevData) => {
              return {
                ...prevData,
                ['status']: orderedData[0].statusId,
              };
            });
          }
          setShipmentStatus(orderedData);
        });
        if (isEORIUser()) {
          getCompanyList().then((data) => {
            // Get the original company list
            const companies = data.data;
            // Add the "ALL" option
            companies.push({ companyId: 'null', companyName: 'ALL' });
            // Sort alphabetically by companyName, but ensure "ALL" is at the top.
            companies.sort((a, b) => {
              // If a is "ALL", it comes first.
              if (a.companyName.toUpperCase() === 'ALL') return -1;
              // If b is "ALL", then a comes after.
              if (b.companyName.toUpperCase() === 'ALL') return 1;
              // Otherwise, sort alphabetically.
              return a.companyName.localeCompare(b.companyName);
            });
            store.companyList[1](companies);
            setSearchData((prevData) => {
              return {
                ...prevData,
                ['companyId']: companies[0].companyId,
              };
            });
            setCompanyList(companies);

            if (Object.keys(searchData).length === 0 && searchData.constructor === Object) {
              store.shipmentStatusFilterData[1]({ companyId: 'null' });
              setValue(companies[0].companyName);
            } else {
              store.shipmentStatusFilterData[1]({ ...searchData });
              var selectedValue = data.data.find((item) => searchData.companyId === item.companyId);
              if (selectedValue?.companyName === undefined) {
                setValue('ALL');
              } else {
                setValue(selectedValue.companyName);
              }
            }

            handlefilterApiCall();
          });
        } else {
          if (Object.keys(searchData).length === 0 && searchData.constructor === Object) {
            store.shipmentStatusFilterData[1]({});
          } else {
            store.shipmentStatusFilterData[1]({ ...searchData });
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);
  return (
    <div className="searchPanelContainer">
      <Container maxWidth="md" className="container-panel">
        {' '}
        {/* Sets maximum width, with automatic margins */}
        <Box
          sx={{
            fontSize: '24px',
            fontWeight: '100',
            fontFamily: 'Roboto',
          }}
          className="header-search"
        >
          Search
        </Box>
        <Box sx={{ flexGrow: 1 }} className="search-container-fields">
          <Grid spacing={8}>
            <Grid>
              <Stack spacing={1}>
                {isEORIUser() && (
                  <Box className="col-wrapper search-col-wrapper">
                    <Typography variant="body1" className="typography">
                      Company
                    </Typography>
                    <Autocomplete
                      value={value}
                      fullWidth
                      className="hover-classes disabled"
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          // User cleared the selection: update searchData but don't immediately display "ALL"
                          setSearchData((prevData) => ({
                            ...prevData,
                            companyId: 'null',
                          }));
                          // Clear the display (it remains empty until search is clicked)
                          setValue(null);
                          companySetEori();
                        } else {
                          setSearchData((prevData) => {
                            return {
                              ...prevData,
                              ['companyId']: newValue?.companyId,
                            };
                          });
                          companySetEori();
                          setValue(newValue?.companyName);
                        }
                      }}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      id="controllable-states-demo"
                      options={companyList}
                      sx={{ width: 300 }}
                      getOptionLabel={(option) => {
                        return `${option.companyName || option}`;
                      }}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            {option.companyName || option}
                          </li>
                        );
                      }}
                      renderInput={(params) => <TextField {...params} label="" />}
                    />
                  </Box>
                )}
                <Box className="col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    Your Reference
                  </Typography>
                  <TextField
                    // required
                    id="outlined-required"
                    // label="Your Ref"
                    defaultValue=""
                    fullWidth
                    className="hover-classes disabled"
                    name="clientJobNumber"
                    value={searchData.clientJobNumber || ''}
                    onChange={handleOnChange}
                  />
                </Box>
                <Box className="col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    Consignment Reference
                  </Typography>
                  <TextField
                    // required
                    id="outlined-required"
                    // label="Your Ref"
                    defaultValue=""
                    fullWidth
                    className="hover-classes disabled"
                    name="consignmentRef"
                    value={searchData.consignmentRef || ''}
                    onChange={handleOnChange}
                  />
                </Box>
                <Box className="col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    ENS LRN/MRN
                  </Typography>
                  <TextField
                    id="outlined-required"
                    // label="ENS LRN"
                    defaultValue=""
                    fullWidth // Ensures it remains full width
                    className="hover-classes disabled"
                    name="lrnMRN"
                    value={searchData.lrnMRN || ''}
                    onChange={handleOnChange}
                    onKeyDown={handleKeyDown}
                  />
                </Box>

                <Box className="col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    Vehicle Identity
                  </Typography>
                  <TextField
                    id="outlined-required"
                    // label="Vehicle Identity"
                    defaultValue=""
                    fullWidth // Ensures it remains full width
                    className="hover-classes disabled"
                    name="vehicleIdentity"
                    value={searchData.vehicleIdentity || ''}
                    onChange={handleOnChange}
                    onKeyDown={handleKeyDown}
                  />
                </Box>

                <Box className="dashboard-search-field col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    Departure Date
                  </Typography>
                  <div className="localton-provider-departure">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="datepicker"
                        defaultValue={null}
                        value={searchData.departureStartDate}
                        onChange={(date) => handleOnChange(date, 'departureStartDate')}
                        name="fromDepartureDate"
                        format="DD/MM/YYYY"
                        timezone="UTC"
                      />
                      <DatePicker
                        className="datepicker"
                        defaultValue={null}
                        value={searchData.departureEndDate}
                        onChange={(date) => handleOnChange(date, 'departureEndDate')}
                        name="toDepartureDate"
                        format="DD/MM/YYYY"
                        timezone="UTC"
                      />
                    </LocalizationProvider>
                  </div>
                  {departureDateError && <Alert severity="error">{departureDateError}</Alert>}
                </Box>

                <Box className="dashboard-search-field col-wrapper search-col-wrapper">
                  {/* Label */}
                  <Typography variant="body1" className="typography">
                    Arrival Date
                  </Typography>
                  <div className="localton-provider-departure">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="datepicker"
                        defaultValue={null}
                        value={searchData.arrivalStartDate}
                        onChange={(date) => handleOnChange(date, 'arrivalStartDate')}
                        name="fromArrivalDate"
                        format="DD/MM/YYYY"
                        timezone="UTC"
                      />
                      <DatePicker
                        className="datepicker"
                        defaultValue={null}
                        value={searchData.arrivalEndDate}
                        onChange={(date) => handleOnChange(date, 'arrivalEndDate')}
                        name="toArrivalDate"
                        format="DD/MM/YYYY"
                        timezone="UTC"
                      />
                    </LocalizationProvider>
                  </div>
                  {arrivalDateError && <Alert severity="error">{arrivalDateError}</Alert>}
                </Box>
                <div className="col-wrapper search-col-wrapper">
                  <Typography variant="body1" className="typography">
                    Status
                  </Typography>
                  <Select
                    labelId="submitter-label-2"
                    id="submitter-select-2"
                    value={searchData.status || 1}
                    name="status"
                    fullWidth // Ensures it remains full width
                    className="hover-classes disabled"
                    onChange={handleOnChange}
                  >
                    {shipmentStatus?.map((item, index) => (
                      <MenuItem value={item.statusId} key={index}>
                        {item.description}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </Stack>
            </Grid>
            {/* Right Column */}
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }} className="button-search-container">
          <button style={{ marginTop: '1rem', marginBottom: '1rem' }} className={'grey-button '} onClick={resetFields}>
            Reset
          </button>
          <button
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
            className={'grey-button '}
            onClick={filterResponse}
            disabled={departureDateError || arrivalDateError}
          >
            {' '}
            Search
          </button>
        </Box>
      </Container>
    </div>
  );
}
SearchContainerPanel.propTypes = {
  handlefilterApiCall: PropTypes.string,
  companySetEori: PropTypes.func,
  handleCompanyNameChange: PropTypes.func,
  onResetPagination: PropTypes.func,
};
